export enum NotificationDeliveryType {
    UNSPECIFIED = 'notification_delivery_type_unspecified',
    IMMEDIATE = 'IMMEDIATE',
    SCHEDULED = 'SCHEDULED',
    RECURRING = 'RECURRING',
}
